import { connect } from 'react-redux'
import { selectShowDemoMailboxBar } from 'selectors/mailboxes'
import {
  selectIsAccountExpired,
  selectShowPendingCancellation,
  selectCancelsAt,
  selectShowCreditCardExpireSoon,
  selectShowCreditCardExpired,
  selectPrimaryCreditCard,
  selectShowLastBillingFailed,
  selectShowTrialMessage,
  selectDaysLeftBeforeExpiring,
} from 'ducks/billing/selectors'
import { selectGitHubNeedsReinstall } from 'ducks/integrations/github'
import { selectShowIOSMobileAppLaunch } from 'selectors/app/base'
import AppNoticesView from './view'

const select = state => ({
  showDemoMailboxBar: selectShowDemoMailboxBar(state),
  showExpiredBilling: selectIsAccountExpired(state),
  showGitHubReauth: selectGitHubNeedsReinstall(state),
  showPendingCancellation: selectShowPendingCancellation(state),
  showCreditCardExpireSoon: selectShowCreditCardExpireSoon(state),
  showCreditCardExpired: selectShowCreditCardExpired(state),
  showLastBillingFailed: selectShowLastBillingFailed(state),
  creditCard: selectPrimaryCreditCard(state),
  cancelsAt: selectCancelsAt(state),
  showTrialMessage: selectShowTrialMessage(state, 'inbox'),
  trialDaysLeft: selectDaysLeftBeforeExpiring(state, 'inbox'),
  showIOSMobileAppLaunch: selectShowIOSMobileAppLaunch(state),
})

export default connect(select)(AppNoticesView)
